import _ from "lodash";

const mergeDataset = (dataset) => {
  const merged = [];

  dataset.forEach((item) => {
    // Check if an existing merged object has a matching 'to.title' or 'from.title'
    const existingIndex = merged.findIndex(
      (mergedItem) =>
        (item.to?.title &&
          mergedItem.to?.title &&
          mergedItem.to.title === item.to.title) ||
        (item.from?.title &&
          mergedItem.from?.title &&
          mergedItem.from.title === item.from.title) ||
        (item.to?.title &&
          mergedItem.from?.title &&
          mergedItem.from.title === item.to.title)
    );

    // If we find a match, merge the systems
    if (existingIndex !== -1) {
      const existing = merged[existingIndex];

      if (item.to?.systems) {
        existing.to = existing.to.title
          ? existing.to
          : { title: item.to.title, systems: [] };
        existing.to.systems = _.uniqBy(
          [...existing.to.systems, ...item.to.systems],
          "id"
        );
      }

      if (item.from?.systems) {
        existing.from = existing.from.title
          ? existing.from
          : { title: existing.from.title, systems: [] };
        existing.from.systems = _.uniqBy(
          [...existing.from.systems, ...item.from.systems],
          "id"
        );
      }
    } else {
      // No match found, so add the item as a new merged object
      merged.push({
        to: item.to
          ? {
              title: item.to.title,
              systems: _.uniqBy(item.to.systems || [], "id"),
            }
          : null,
        from: item.from
          ? {
              title: item.from.title,
              systems: _.uniqBy(item.from.systems || [], "id"),
            }
          : null,
      });
    }
  });

  return merged;
};

export default mergeDataset;
